import "./rhythm-button.js";

class RhythmContainer extends HTMLElement {
  #type = undefined;
  #label = undefined;

  constructor() {
    super();
  }

  async connectedCallback() {
    this.#type = this.getAttribute("data-type");
    this.#label = this.textContent;
    this.textContent = "";
    this.innerHTML = `<div class='header'>${this.#label}</div>
      <div class='rhythm-container'></div>
    `;

    const rhythmContainer = this.querySelector(".rhythm-container");

    for (let i = 1; i <= 9; i++) {
      rhythmContainer.innerHTML += `<rhythm-button data-type="${this.#type}">${i}</rhythm-button>`;
    }
  }
}

customElements.define("rhythm-container", RhythmContainer);
